<template>
  <!-- name: '幻灯片组件' -->
  <div class="swiperBox">
    <swiper :options="curOption">
      <swiper-slide v-for="(item, index) in bannerList" :key="index">
        <img
          :src="item.url"
          alt=""
          class="bannerImg"
          @click="
            $router.push({
              path: '/donateThird',
              query: { title: '项目详情', id: item.id, nextPath: '/home' },
            })
          "
        />
      </swiper-slide>
      <div class="swiper-pagination" slot="pagination"></div>
    </swiper>
  </div>
</template>

<script>
export default {
  props: {
    bannerList: {
      type: Array,
      default: () => [],
    },
    swiperOption: {
      type: Object,
      default: () => {},
    },
  },
  components: {},
  data() {
    return {
      defaultOption: {
       pagination: {
          el: '.swiper-pagination', // 指定分页器容器
          clickable: true // 分页器可点击
        },
        navigation: { // 导航配置
          nextEl: '.swiper-button-next', // 下一页按钮
          prevEl: '.swiper-button-prev'  // 上一页按钮
        },
        autoplay: { // 自动播放配置
          delay: 3000, // 5秒切换一次
          disableOnInteraction: false // 用户操作后继续自动播放
        },
        loop: true, // 循环播放
        // spaceBetween: 15, // 图片之间的间距
        // centeredSlides: true, // 居中还是从图1开始
        // notNextTick: true, // true:加载后允许触发事件 false:加载后不可以触发事件
        // initialSlide: 0, // 从第几个开始
        // speed: 800, // 滑动时候动画的速度
        // paginationClickable: true, // 下面按钮让点吗
         observer: true, // 启用观察器
        observeParents: true, // 观察父元素变化
      },
      mdv: [], // 存放图片数据的数组
    };
  },
  created() {
    this.setOption();
  },
  methods: {
    setOption() {
      this.curOption = { ...this.swiperOption, ...this.defaultOption };
    },
  },
};
</script>

<style lang="scss" scoped>
.swiperBox {
  widows: 100%;
  overflow: hidden;
  ::v-deep .swiper-wrapper {
    height: 316px;
  }
  .swiper-slide {
    background: #ffffff;
    display: flex;
    justify-content: center;
    border-radius: 16px;
    align-items: baseline;
  }
  .bannerImg {
    border-radius: 16px;
    background: #ffffff;
    max-height: 316px;
    overflow: hidden;
    object-fit: contain;
  }
  ::v-deep .swiper-pagination-bullet {
    background: #ffffff;
    opacity: 0.3;
  }
  ::v-deep .swiper-pagination-bullet-active {
    background-color: #fff;
    opacity: 1;
  }
}
</style>
